export default function appToasts(state) {
  return state.appToasts;
}
